import styled from 'styled-components';

const IconButtonWrapper = styled.button`
  border-radius: 8px;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: inherit;
`;

export default IconButtonWrapper;
